let ContentServerClient = require("../../ContentServerClient.js");

//Max number elements accepted by the server in one request
const MAX_ELEMENTS = 200;

class LibraryLoader{

    constructor(){}
    
    getGeneral(handleError, id){
        return ContentServerClient.getFile(handleError, undefined, id, `/`);
    }
    
    loadExplicit(handleError, id){
        this.mapElements = [];

        return this.getPackages(handleError, id)
                    .then(info => this.getExplicitElements(info))
                    .then(info => this.makeQuery(this.handleLenght(this.mapElements = info)))
                    .then(info => this.getRequest(handleError, info))
                    .then(info => this.getChildrensExplicit(info))
                    .then(info => this.addExplicitElements(info, this.mapElements))
                    .then(this.becomeObject);
    }

    loadImplicit(handleError, data){
        let mapImplicits = {symbol: data.symbols, "package": data.packages, footprint: data.footprints};

        return this.getRequest(handleError, this.makeQuery(this.handleLenght(mapImplicits)))
                    .then(info => this.getChildrenImplicit(info))
                    .then(info => this.addImplicitData(info, mapImplicits, this.mapElements))
                    .then(info => {this.updateMapElements(Object.entries(info), this.mapElements); return info})
                    .then(info => this.checkImplicitPackages(handleError, info, mapImplicits, this.mapElements))
                    .then(info => {this.updateMapElements(Object.entries(info), this.mapElements); return info})
    }

    /**
     * It search the elements that contain the property "contains" and replace it with detailed information about the elements
     * @param { Map } data - Accumulator of All elements (implicit and explicit)
     * @return { Obj } - New formated obj.
     */
    addInfoContains(data){
        Object.entries(data).forEach(([name, items]) => {
            if(name === "component" || name === "package"){
                items.forEach(info => {
                    let [id, obj] = info;
                    if(obj.contains){
                        let detailContains = this.searchItems(this.mapElements, obj.contains)
                                                    .map(({id, type, name, summary}) => ({id, type, name, summary}));
                        obj.contains = detailContains;
                    }
                })
            }
        }); return data;
    }

    getPackages(handleError, id){
        return ContentServerClient.getColabDoc(handleError, "libraries", id);
    }

    /**
     * @param { object:{ object: { array } } } assets - has the explicit children of the library.
     * @return { Map: {Map: {type: info}} } result of children's extraction.
     */
    getExplicitElements({ body: { assets }}){
        return assets.reduce( (acum, {$asset}) => this.extractElements($asset, acum), new Map() );
    }

    /**
     * Receive elements and will make a string with each type of element
     * @param { Map | object | Array } info - Has array with the type, id and version of element.
     * @return { Array } - Each position of array has a type of element that contains a concatenate string..
     */
    makeQuery(info){
        let data = info instanceof Map ? Array.from(info) : 
                    info instanceof Array ? info : Object.entries(info);

        return  data.reduce((acum, [name, elements]) => {
                    return [...acum, Array.from(elements).reduce((iAcum, [id, {version}]) => iAcum += `&${name}:${id}:${version}`, "")]
                },[]);
    }

    /**
     * Check the length of elements and call the function that split it into small pieces
     * @param { Map | Obj } info - Has the type and Map with elements
     * @return { Array } - A new array that its higher or is equal to MAX_ELEMENTS  
     */
    handleLenght(data){
        data = data instanceof Map ? Array.from(data) : Object.entries(data);
        
        return data.reduce((acum, [name, [...elements]]) => {
            if(elements.length > MAX_ELEMENTS){
                return acum = [...acum, ...this.splitArray(name, elements)];
            }
            return acum = [...acum, [name, elements]]
        }, [])
    }

    /**
     * Split array into small pieces
     * @param { String } name - Property's name (packages, footprint, Symbol)
     * @param { Array } data - Array of elements
     * @return { Array } - New array equal or short as a MAX_ELEMENTS constant.
     */
    splitArray(name, data){
        let loopNumber = 1;
        let start = 0;
        let end = MAX_ELEMENTS;
        let newArray = [];
        const numPieces =  Math.ceil(data.length / MAX_ELEMENTS);

        while (numPieces >= loopNumber){
            end = loopNumber * MAX_ELEMENTS;
            start = (loopNumber - 1) * MAX_ELEMENTS;
            if(numPieces === loopNumber){end = data.length}
            newArray.push([name, data.slice(start, end)])
            loopNumber++;
        }

        return newArray;
    }

    /**
     * Loop through a concatenate string and make a request with it, finally concat all the responses
     * @param { Array } info - Each position of array has a type of element that contains a concatenate string
     * @return { Array } - Has the whole of responses.
     */
    getRequest(handleError, info){
        let promises = info.map(query => ContentServerClient.getMultiSavedSnapshot(handleError, query));
        return Promise.all(promises).then(elements => this.concatAll(elements));
    }

    /**
     * Loop through a concatenate response
     * @param { Array } info - Has the elements returned by the server
     * @return { Object: {type, Map: {id, info}} } - Information organized by type and nested in a Map.
     */
    getChildrensExplicit(info){
        return info.reduce((acum, data) => this.extractExplicitData(data, acum), {});
    }

    /**
     * Each children is going to be extracted and organized in a new object by type
     * @param { header: {resource, assetId }} - Element's information
     * @param { obj } acumulator - Has the formatted elements
     * @return { obj } - formatted element.
     */
    extractExplicitData({ header: {resource, assetId}, body }, acumulator){
        let { composedSymbol: { symbolInstances } = {symbolInstances: undefined}, packageInstances, footprintInstances } = body;        
        
        let hasModel3d = false;
        if(body.model3d){
            hasModel3d = body.model3d.$class;
        } 

        let symbols = new Map(), packages = new Map(), footprints = new Map();

        if(hasModel3d){
            resource = Object.assign(resource, {hasModel3d})
        }
    
        if(symbolInstances && Object.values(symbolInstances).length > 0){
            symbols = this.mapChildrens(Object.values(symbolInstances), assetId).get("symbol");
        }
        
        if(packageInstances && packageInstances.length > 0){
            packages = this.mapChildrens(packageInstances, assetId).get("package");
        }
        
        if(footprintInstances && footprintInstances.length > 0){
            footprints = this.mapChildrens(footprintInstances, assetId).get("footprint");
        }

        let newImplicit = this.AddIdChildres(resource, symbols, packages, footprints);

        if(Object.values(acumulator).length === 0){ return newImplicit };

        return this.addIdParent(newImplicit, acumulator);
    }

    /**
     * Save parent's id into each children, the result is delivered as a map
     * @param { Obj } data - childrens
     * @param { Number } assetId - Id parent
     * @return { Map } - formatted element.
     */
    mapChildrens(data, assetId){
        return data.reduce( (acum, {ancestor: {$asset}}) => {
            return this.extractElements(Object.assign($asset, {useIn: [assetId]}), acum)
        }, new Map());
    }
    
    /**
     * Save the children's' id into a its parent's "contains" property
     * @param { Obj } resource - Parent
     * @param { Array } childrens - Matrix that contains all children's ids
     * @return { Obj } - formatted element.
     */
    AddIdChildres(resource, ...childrens){
        let [symbols, packages, footprints] = childrens;
        let contains = childrens.reduce((acum, element) => {
            return [...acum, ...Array.from(element).map(([id]) => id)];
        }, []);

        return  { resource: [Object.assign(resource, {contains})], symbols, packages, footprints };
    }

    //Add relation between the child with its parent (array useIn)
    addIdParent(newImplicit, implicits){
        return Object.entries(newImplicit).reduce((acum, [name, itemsMap]) => {
                    if(name === "resource"){
                        acum.resource = [...acum.resource, ...newImplicit.resource];
                    }else{
                        itemsMap.forEach(data => { let {id, useIn} = data;
                            if(acum[name].has(id)){
                                acum[name].get(id).useIn.push(...useIn);
                            }else{
                                acum[name].set(id, data)
                            }
                        });
                    } return acum;
                }, implicits);
    }

    /**
     * check the Map and add the new element, it not save elements duplicates
     * @param { object } - has information about an element.
     * @param { Map } - target.
     * @return { Map } - the same map recived as a parameter.
     */
    extractElements({type, id, version, useIn = [], contains = [], hasModel3d = false }, map){
        id = Number(id);
        useIn = useIn.map( id => id = Number(id));
        
        if(map.has(type)){
            if(!map.get(type).has(id)){
                map.get(type).set(id, {id, version, useIn, contains, hasModel3d});
            }
        }else{
            map.set(type, new Map().set(id, {id, version, useIn, contains, hasModel3d}));
        }
        return map;
    }

    /**
     * It format and Update the target elements with the new newElements' information
     * @param { Obj } newElements - Has all the information about Explicits elements
     * @param { Map } target - Has all the ids of Explicits elements
     * @return { Obj } - Final object with the whole of explicit elements' information and implicits elements.
     */
    addExplicitElements(newElements, target){
        let {symbols, packages, footprints, resource} = newElements;

        if(target instanceof Map){
            resource.forEach(info => {
                let {id, name, user_name, summary, type, created_at, contains, hasModel3d = false } = info;
                id = Number(id);
                let map = target.get(type);
                let version = map.get(id).version;
                let [{ time: updated_at }] = info.save_points.filter(data => data.version === version);
                map.set(id, {id, name, user_name, summary, type, version, updated_at, created_at, contains, hasModel3d, explicit: true});
            })
        }

        return {target, implicits: {symbols, packages, footprints}};
    }

    /**
     * Map elements is become to a Obj
     * @param { Map } info -
     * @return { Obj } -
     */
    becomeObject(info){
        let obj = { implicits: info.implicits};
        info.target.forEach((elements, name) => Object.assign(obj, {[name]: [...elements]}) );
        return obj;
    }

    /**
     * It picks the necessary information and returns a newly organized obj
     * @param { Array } data - Elements returned by server
     * @return { Obj } - formatted element.
     */
    getChildrenImplicit(data){
        return  data.reduce((acum, {header:{resource, assetType: type, version}, body}) => {
                    let [{ time: updated_at }] = resource.save_points.filter(data => data.version === version);
                    
                    let hasModel3d = false;
                    if(body.model3d){
                        hasModel3d = body.model3d.$class;
                    } 
                    
                    let { name, summary, created_at, user_name } = resource;
                    let id = Number(resource.id);

                    if(acum[type]){
                        acum[type] = [...acum[type], {type, id, name, summary, updated_at, created_at, user_name, version, hasModel3d}];
                    }else{
                        acum[type] = [{type, id, name, summary, updated_at, created_at, user_name, version, hasModel3d}];
                    } return acum;
                }, {})

    }

    /**
     * It validates the if the implicits elements contains Packages
     * if it has it search its childrens and return a new obj formated
     * @param { Obj } newData - New elements
     * @param { Map } mapData - Accumulator of Implicit elements
     * @param { Map } mapExplicits - Accumulator of All elements (implicit and explicit)
     * @return { Obj } - New update obj.
     */
    checkImplicitPackages(handleError, newData, mapData, mapExplicits){
        if(newData.package){
            return this.getRequest(handleError, this.makeQuery(this.handleLenght({package: mapData.package})))
                            .then(info => this.getChildrensExplicit(info))
                            .then(({resource, footprints}) => {
                                //Update newData's property "contains" thus it make a relationship with its children
                                newData.package = newData.package.map(([id, data], index) => [id, Object.assign(data, {contains: resource[index].contains})]);
                                //Add the new footprints' ids in the mapData accumulator
                                Array.from(footprints).forEach(([id, data]) => mapData.footprint.set(id, data));
                                return footprints;
                            })
                            .then(footprint => this.makeQuery(this.handleLenght({footprint})))
                            .then(info => this.getRequest(handleError, info))
                            .then(info => this.getChildrenImplicit(info))
                            .then(info => this.addImplicitData(info, mapData, mapExplicits))
                            .then(info => {
                                if(newData.footprint){ newData.footprint = [...newData.footprint, ...info.footprint];
                                }else{ newData.footprint = info.footprint }
                                return Object.assign(newData);
                            });
        }else{
            return newData;
        }
    }

    /**
     * The general map accumulator is updated with the new elements
     * @param { Map } data - New elements
     * @param { Map } mapElements - Accumulator
     */
    updateMapElements(data, mapElements){
        if(mapElements instanceof Map){
            data.forEach(([name, items]) => {
                if(mapElements.has(name)){
                    items.forEach(([id, obj]) => mapElements.get(name).set(id, obj))
                }else{
                    mapElements.set(name, new Map([...items]))
                }
            })
        }
    }

    /**
     * It update the "mapData" with the new information got tho the server and merge the Array "useIn" with its detailed elements
     * @param { Obj } newData - New elements
     * @param { Map } mapData - Accumulator of Implicit elements
     * @param { Map } parents - Accumulator of All elements (implicit and explicit)
     * @return { Obj } - New update obj.
     */
    addImplicitData(newData, mapData, parents){
        return Object.entries(newData).reduce((acum, [name, items]) => {
                    acum[name] = items.reduce((icum, data) => {
                                    let { id } = data;
                                    let idsUseIn = mapData[name].get(id).useIn;
                                    return [...icum, [id, Object.assign(data, {useIn: this.searchItems(parents, idsUseIn)})]]
                                },[]);
                                return acum;
                }, {})
    }
    
    /**
     * It search the ids into parent and return information for each
     * @param { Map } parents - 
     * @param { Array } ids - Elements for searching
     * @return { Array: { obj } } - Has the detailed information about the parameters' ids
     */
    searchItems(parents, ids){
        let infoComponent = [];
        parents.forEach(component => ids.forEach(id => {
                if(component.has(id)){
                    infoComponent = [...infoComponent, component.get(id)];
                }
            }))
        return infoComponent;
    }

    concatAll(data){
        return data.reduce((acum, subArray) =>  [...acum, ...subArray] , []);
    }

    sort(data){
        return Object.entries(data).reduce((acum, [name, items]) => {
            
            return Object.assign(acum, {[name]: items.sort(([aId, aObj], [bId, bObj]) => {
                                                            let x = aObj.name.toLowerCase();
                                                            let y = bObj.name.toLowerCase();
                                                            return x < y ? -1 : x > y ? 1 : 0;
                                                        })
                                        });
        }, {finished: true});
    }
}

module.exports = new LibraryLoader();
